import React, { useRef, useMemo } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import * as THREE from "three";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Mosaic official blue from your branding
const mosaicBlue = "#3498DB";

function BackgroundPoints() {
  const pointsRef = useRef();

  // generate point cloud once
  const geometry = useMemo(() => {
    const points = [];
    for (let i = 0; i < 1000; i++) {
      points.push(
        new THREE.Vector3(
          (Math.random() - 0.5) * 50,
          (Math.random() - 0.5) * 50,
          (Math.random() - 0.5) * 50
        )
      );
    }
    return new THREE.BufferGeometry().setFromPoints(points);
  }, []);

  // slow rotation animation
  useFrame(() => {
    if (pointsRef.current) {
      pointsRef.current.rotation.y += 0.0008;
      pointsRef.current.rotation.x += 0.0003;
    }
  });

  return (
    <points ref={pointsRef}>
      <bufferGeometry attach="geometry" {...geometry} />
      <pointsMaterial attach="material" color={mosaicBlue} size={0.05} />
    </points>
  );
}

export default function Background() {
  return (
    <Canvas
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: -1,
        width: "100%",
        height: "100%",
      }}
    >
      <ambientLight />
      <BackgroundPoints />
    </Canvas>
  );
}
